import Icon from '../../../components/AppIcon';

const EarningsOverview = ({ totalEarnings, totalWithdrawn, totalPoints, withdrawalEligible, withdrawalMinimum }) => {
  const progressPercentage = Math.min((totalEarnings / withdrawalMinimum) * 100, 100);
  const pointsToBonus = 1000;
  const pointsProgress = Math.min((totalPoints / pointsToBonus) * 100, 100);

  return (
    <div className="bg-card rounded-lg shadow-card p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-foreground">Resumen de Ganancias</h2>
        <div className={`px-4 py-2 rounded-lg ${withdrawalEligible ? 'bg-success text-success-foreground' : 'bg-muted text-muted-foreground'}`}>
          <Icon name={withdrawalEligible ? 'CheckCircle' : 'Clock'} size={20} className="inline mr-2" />
          <span className="font-medium">{withdrawalEligible ? 'Retiro Disponible' : 'En Progreso'}</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="bg-gradient-to-br from-primary to-secondary p-6 rounded-lg text-primary-foreground">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm opacity-90">Total Retirado</span>
            <Icon name="DollarSign" size={24} />
          </div>
          <div className="text-3xl font-bold mb-1">${totalWithdrawn?.toLocaleString('es-CO')}</div>
          <div className="text-xs opacity-80">COP retirados acumulados</div>
        </div>

        <div className="bg-gradient-to-br from-accent to-warning p-6 rounded-lg text-accent-foreground">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm opacity-90">Puntos Acumulados</span>
            <Icon name="Award" size={24} />
          </div>
          <div className="text-3xl font-bold mb-1">{totalPoints?.toLocaleString('es-CO')}</div>
          <div className="text-xs opacity-80">5 puntos por referido</div>
        </div>
      </div>
      <div className="space-y-6">
        <div>
          <div className="flex items-center justify-between mb-3">
            <div>
              <h3 className="text-sm font-semibold text-foreground">Progreso para Retiro</h3>
              <p className="text-xs text-muted-foreground">Mínimo: ${withdrawalMinimum?.toLocaleString('es-CO')} COP</p>
            </div>
            <span className="text-sm font-bold text-primary">{progressPercentage?.toFixed(0)}%</span>
          </div>
          <div className="w-full bg-muted rounded-full h-3 overflow-hidden">
            <div 
              className="bg-gradient-to-r from-primary to-secondary h-full rounded-full transition-all duration-500"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Faltan ${(withdrawalMinimum - totalEarnings)?.toLocaleString('es-CO')} COP para retiro
          </p>
        </div>

        <div>
          <div className="flex items-center justify-between mb-3">
            <div>
              <h3 className="text-sm font-semibold text-foreground">Progreso a Bono</h3>
              <p className="text-xs text-muted-foreground">1.000 puntos = $1.000.000 COP</p>
            </div>
            <span className="text-sm font-bold text-accent">{pointsProgress?.toFixed(0)}%</span>
          </div>
          <div className="w-full bg-muted rounded-full h-3 overflow-hidden">
            <div 
              className="bg-gradient-to-r from-accent to-warning h-full rounded-full transition-all duration-500"
              style={{ width: `${pointsProgress}%` }}
            />
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Faltan {(pointsToBonus - totalPoints)?.toLocaleString('es-CO')} puntos para bono
          </p>
        </div>
      </div>
    </div>
  );
};

export default EarningsOverview;